import { render, staticRenderFns } from "./LoadingBaseList.vue?vue&type=template&id=0fe52a8c&lang=pug"
import script from "./LoadingBaseList.vue?vue&type=script&lang=js"
export * from "./LoadingBaseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports